import React, { useEffect } from 'react';
import { layout } from 'Constants';

// Components
import { Container, Anchor, Footnote } from 'Components/core';
import Hero from './components/Hero';
import Cards from './components/Cards';
import InfoBox from 'Components/InfoBox';

// Images
import AppStoreIOS from 'Images/store-icon-ios.png';
import AppStoreAndroid from 'Images/store-icon-android.png';
import Connect from './images/ASA_Section_Titles_02.jpeg';
import { Subscribe } from 'laco-react';
import { ApiStore } from 'Root/store';
import CODES from 'Root/libs/analytics/CodeDef';
import Alert from './components/Alert';
import styled from 'styled-components';
import Api from 'Root/libs/analytics/Api';
import { toArray } from 'Root/libs/array';
import { replaceAnchor } from 'Root/libs/anchor';

export default () => {

  useEffect(()=>{
    Api.recordAcitity(CODES.HOME_PAGE_OPEN);
  },[]);


  
  return (
    <Subscribe to={[ApiStore]}>
      {state => (
        <Container column>
          <Hero />
   
          <Container
            seperation="32px"
            column
            margin="32px auto"
            style={{
              maxWidth: layout.maxWidth,
              width: '100%'
            }}
          >
        
            <Cards/>
              
            {state?.asaEnrollWaive && <InfoBox header={state?.asaEnrollWaive?.headLine}>
        
              {toArray(state?.asaEnrollWaive?.Content).map(html=><p dangerouslySetInnerHTML={{__html:replaceAnchor(html)}}></p>)}
 
            </InfoBox>}


            {state?.asaFindCare && <InfoBox header={state?.asaFindCare?.headLine}>
        
        {toArray(state?.asaFindCare?.Content).map(html=><p dangerouslySetInnerHTML={{__html:replaceAnchor(html)}}></p>)}

      </InfoBox>}


          </Container>
        </Container>
      )}
    </Subscribe>
  );

};
